export default "__VITE_ASSET__Dsszfv6J__"